export default __webpack_public_path__ + "static/media/home-wall.39e607d0.jpg";